export default "__VITE_ASSET__CoGmZ4RZ__"